import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewContainerRef, ComponentRef, HostListener, OnDestroy, ElementRef } from '@angular/core';
//import { Item } from '@progress/kendo-angular-grid/dist/es2015/data/data.iterators';
import { ChartComponent } from '@progress/kendo-angular-charts';
import { filterItem } from '../../models/filterItem';
import { DashboardQueries } from '../../enums/DashboardQueries';
import { DashboardType } from '../../enums/DashboardType';
import { WidgetSearch } from '../../models/WidgetSearch';
import { DashboardService } from '../../services/dashboard.service';
import { GlobalsService } from '../../services/globals.service';
import { BaseGridComponent } from '../../base-components/base-grid.component';
import { Subscription } from 'rxjs';

import { DashboardWidgetService } from '../../services/dashboardWidget.service';
import { widgetFilters } from '../../enums/widgetFilters';
import { WindowContents } from '../../enums/windowContents';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { CommonFunctions } from '../../static/common-functions';
import { GItem } from '../../models/GItem';
import { DataItem } from "@progress/kendo-angular-grid";
import { FeatureFlagService } from '../../services/feature-flag.service';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../../decorators/featureflags/featureflagset-decorator';

function mm(val: number): number {
    return val * 2.8347;
}
@UseFeatureFlagSet()

@Component({
    selector: 'chart-widget',
    templateUrl: './chart-widget.component.html',
    styleUrls: ['./chart-widget.component.scss']
})
export class ChartWidgetComponent  implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any; //Move this inside class
    subscriptions: Subscription[] = [];
    subs_dataRefUpdated: Subscription;
    constructor(private globals: GlobalsService, private svc_data: DashboardService, private svc_dashWidget: DashboardWidgetService, private el: ElementRef, qry_rd: DQOIReferenceDataQuery, private featureFlagService: FeatureFlagService) {

        this.qry_rd = qry_rd;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
        this.featureFlagService = featureFlagService;

        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                if (this.searchParam) {
                    this.search(this.searchParam);
                }
            }));
        this.subscriptions.push(svc_data.dispatchReviewRefresh$.subscribe(
            refresh => {
                if (this.dashboardQuery == DashboardQueries.dispatchReviewLite && this.searchParam) {
                    this.search(this.searchParam);
                }
            }));
        this.subscriptions.push(svc_data.generalWidgetRefresh$.subscribe(
            refresh => {
                if ((this.dashboardQuery == DashboardQueries.openDispatches || this.dashboardQuery == DashboardQueries.openContracts || this.dashboardQuery == DashboardQueries.pendingChangeOrders || this.dashboardQuery == DashboardQueries.    invoiceApprovals) && this.searchParam) {
                    this.search(this.searchParam);
                }
            }));
        this.w_width = window.innerWidth;
        this.setDimensions();
    }
    subs_widgetEvent: Subscription;
    public refresh() {
        this.search(this.searchParam);
    }
    ngOnInit() {
        if (this.inputSearchParams) {
            this.searchParam = this.inputSearchParams;
        }
    }

    ngOnDestroy() {
        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = null;
        }
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    private resizeTimer: any;
    private lastChartWidth: number | null = null;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // Debounce chart geometry updates to avoid resize-storm redraws on small screens.
        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
        }
        this.resizeTimer = setTimeout(() => {
            this.w_width = window.innerWidth;
            this.setDimensions();
        }, 150);
    }

    setDimensions() {
        // Keep charts usable on phones instead of forcing a 500px minimum.
        const responsiveMin = this.w_width < 768
            ? Math.max(220, Math.floor(this.w_width * 0.9))
            : this.chartMinWidth;
        let temp = this.w_width * this.chartWidthPct;
        temp = temp < responsiveMin ? responsiveMin : temp;
        temp = temp > this.chartMaxWidth ? this.chartMaxWidth : temp;
        temp = Math.floor(temp);
        if (this.lastChartWidth === temp) {
            return;
        }
        this.lastChartWidth = temp;
        this.chartWidth = temp;
        this.chartHeight = this.chartWidth;
    }

    loadingData: boolean = false;
    chartMinWidth: number = 500;
    chartMaxWidth: number = 1000;
    chartWidthPct: number = .7;
    w_width: number;
    w_height: number;
    chartWidth: number = 1000;
    chartHeight: number = 1000;

    @ViewChild('chart') private chart: ChartComponent;
    @ViewChild("detailsContainer", { read: ViewContainerRef }) detailsContainer;
    @ViewChild("popupContainer", { read: ViewContainerRef }) popupContainer;

    @Input() dashboardType: DashboardType = DashboardType.donut;
    @Input() dashboardQuery: DashboardQueries;
    @Input() detailsTitleStart: string = '';

    @Input() searchFilters: widgetFilters[] = [];

    @Input() openStatusesOnly: boolean = true;

    @Input() inputSearchParams: WidgetSearch;

    @Output() openStatusesOnlyChange = new EventEmitter<boolean>();
    @Output() chartItemSelected = new EventEmitter<any>();

    @Output() seriesChange = new EventEmitter<filterItem>();
    @Output() searchParams = new EventEmitter<WidgetSearch>();
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();

    loaderError: boolean = false;

    currentOpenStatusesOnly: boolean;
    data: any;
    dataCount: number;
    gridData: any;
    alteredData: DataItem[];

    @Input() chartType: string;

    componentRef: ComponentRef<BaseGridComponent<null, null>>[] = [];
    count: number = 0;
    detailsActive: boolean = false;
    detailsTitle: string;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;

    public show: boolean = false;

    public iconClass: string = 'fa fa-file';
    public exportData: Array<any> = [
        {
            text: 'Full Size',
        }, {
            text: 'Scaled'
        }];
    constIsSubs: GItem[] =
        [
            { value: "0", description: "All", category: null, canSelect: true, reference: null },
            { value: "1", description: "True", category: null, canSelect: true, reference: null },
            { value: "2", description: "False", category: null, canSelect: true, reference: null },
        ]
    disputeAmmount: GItem[] =
        [
            { value: "0", description: "All", category: null, canSelect: true, reference: null },
            { value: "1", description: "1- 50 ", category: null, canSelect: true, reference: null },
            { value: "2", description: "50.01-100", category: null, canSelect: true, reference: null },
            { value: "3", description: "100+", category: null, canSelect: true, reference: null },
        ]
    legendClasses = ['chart-color blue',
        'chart-color red',
        'chart-color green',
        'chart-color purple',
        'chart-color lightblue',
        'chart-color yellow'];

    detailOpened: boolean = false;
    searchParam: WidgetSearch;

    selectedFilters: WidgetSearch;
    subs_dataRef: Subscription;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;

    customerFilters: any;
    acctClassFilters: any;
    salesPersonFilters: any;
    buyersFilters: any;
    srvConstFilters: any;
    techCreatedFilters: any;
    acctManagerFilters: any;
    contractAdminFilters: any;
    serviceManagerFilters: any;
    techniciansFilters:any;
    billerFilters: any;
    invoiceStatusFilters: any;
    daysAgedFilters: any;
    dispatchStatusFilters: any;
    locationsFilters: any;
    assignmentStatusFilters: any;
    divisionFilters: any;
    regionFilters: any;
    onCallRegionFilters: any;
    defaultSubmitterFilters: any;
    discreetBillerFilters: any;
    purchasersFilters: any;
    priorityFilters: any;
    projectManagerFilters: any;
    rankFilters: any;

    search(searchParam: WidgetSearch) {
        this.hideError();

        this.searchParam = searchParam;
        //alert(JSON.stringify(this.searchParam));
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.globals.userId;
        if (this.searchParam.customSearch || this.searchParam.emptySearch) {
            this.show = false;
            this.showSpinner();
            //used in dashboard.service.ts for feature flag evaluation
            this.svc_data.featureFlagCreditMemoApprovalWidgetHighPriorityChangesPt2 = this.compFeatureFlagSet.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"];
            this.svc_data.getDashboardQuery(this.dashboardQuery, this.searchParam).subscribe(data => {
                //Launch darkly flag for 453 credit-memo-approval-widget-high-priority-changes-pt-2
                if (this.compFeatureFlagSet.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"]) {
                    if (data == null || data.saveError || data.hasPrimaryReturn == false) {
                        this.handleNetworkError(data);
                    } else {
                        this.convertDataForChart(this.dashboardQuery, data);
                    }
                } else {
                    if (data == null || data.saveError || data.hasPrimaryReturn == false) {
                        this.handleNetworkError(data);
                    } else {
                        this.convertDataForChart(this.dashboardQuery, data);
                    }
                }
                this.setFilteredItemsDisplay();
                this.show = false;
                this.hideSpinner();
            },
            error => this.handleNetworkError(error));
        } else {
            this.show = true;
            this.hideSpinner();
        }
    }

    handleNetworkError(error) {

        this.hideSpinner();
        this.showError();
    }
    convertDataForChart(chart, data) {
        switch (chart) {
            case (DashboardQueries.purchaseOrderSummary):
                this.data = [];
                this.gridData = data;
                data.forEach(item => {
                    let description = item.supplierName;
                    let value = item.total;
                    this.data.push({ "description": description, "value": value });
                });
                break;
            case (DashboardQueries.techHoursSummary):
                this.data = [];
                this.gridData = data;
                data.forEach((item, index) => {
                    let searchIndex = this.data.findIndex((elem, i) => { return elem.description === item.name; });
                    if (searchIndex > -1) {
                        this.data[searchIndex].value = this.data[searchIndex].value + item.hoursWorked;
                    } else {
                        this.data.push({ "description": item.name, "value": item.hoursWorked });
                    }
                    this.data.sort(function (a, b) {
                        var textA = a.description.toUpperCase();
                        var textB = b.description.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                });
                break;
            case (DashboardQueries.techStatSummary):
                this.data = data.primaryReturn;
                this.gridData = data.primaryReturn;
                break;
            case (DashboardQueries.monthlyInvoiceSalesDetail):
                this.data = [];
                this.gridData = data.primaryReturn;
                let profit = [];
                let sales = [];
                let costs = [];
                let taxes = [];
                let matCosts = [];
                let matSales = [];
                let labCosts = [];
                let labSales = [];
                let months = [];
                data.primaryReturn.forEach(item => {
                    profit.push(item.profitAmount);
                    sales.push(item.salesAmount);
                    costs.push(item.costAmount);
                    taxes.push(item.taxAmount);
                    matCosts.push(item.materialCost);
                    matSales.push(item.materialSale);
                    labCosts.push(item.laborCost);
                    labSales.push(item.laborSale);
                    months.push(item.salesMonth);
                });
                this.data = {
                    "profit": profit,
                    "sales": sales,
                    "costs": costs,
                    "taxes": taxes,
                    "matCosts": matCosts,
                    "matSales": matSales,
                    "labCosts": labCosts,
                    "labSales": labSales,
                    "months": months
                };

                break;
            case (DashboardQueries.invoiceSalesSummary):

                this.data = [];
                this.gridData = data.primaryReturn;

                this.data = this.gridData;
                break;
            case (DashboardQueries.openQuotes):
                this.data = data.primaryReturn.sort((a, b) => (a.description > b.description) ? 1 : -1);
                this.dataCount = data.primaryReturn.reduce((a, b) => a + (b.value || 0), 0);
                this.gridData = data.primaryReturn.sort((a, b) => (a.description > b.description) ? 1 : -1);
                break;
            case (DashboardQueries.creditMemoApproval):

                if(this.compFeatureFlagSet.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"]) {
                    this.data = data.resultList.sort((a, b) => (a.description > b.description) ? 1 : -1);
                    this.dataCount = data.resultList.reduce((a, b) => a + (b.value || 0), 0);
                    this.gridData = data.resultList.sort((a, b) => (a.description > b.description) ? 1 : -1);
                } else {
                    this.data = data.primaryReturn.sort((a, b) => (a.description > b.description) ? 1 : -1);
                    this.dataCount = data.primaryReturn.reduce((a, b) => a + (b.value || 0), 0);
                    this.gridData = data.primaryReturn.sort((a, b) => (a.description > b.description) ? 1 : -1);
                }

                break;
            default:
                this.data = data.sort((a, b) => (a.description > b.description) ? 1 : -1);
                this.dataCount = data.reduce((a, b) => a + (b.value || 0), 0);
                this.gridData = data.sort((a, b) => (a.description > b.description) ? 1 : -1);

        }
    }

    showSpinner() {
        this.loaderState.emit(true);
    }

    hideSpinner() {
        this.loaderState.emit(false);
    }

    showError() {
        this.loaderError = true;
        this.loaderErrorState.emit(this.loaderError);
    }

    hideError() {
        this.loaderError = false;
        this.loaderErrorState.emit(this.loaderError);
    }

    public legendLabelData(data: any) {
        return data.text + ': ' + data.value;
    }

    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        } else {
            filter.value = null;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        //this.createComponent(DisplayTarget.bottom, FactoryComponents.Dispatches, this.searchParam);
        this.chartItemSelected.emit(filter);
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();
        this.hideSpinner();
    }

    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        //this.windowData = {};
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    onClosed(e) {
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    public onSeriesClick(e: any) {
        this.showSpinner();
        this.setDetailData(e.category);
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.setDetailData();
    }

    public onPlotAreaClick(e: any) {
    }

    public onLegendItemClick(category: string): void {
        this.showSpinner();
        this.setDetailData(category);
    }

    public onLegendItemHover(e: any): void {
        e.sender.showTooltip(point => point.index === e.pointIndex);
    }

    public labelContent = (e: any) => {
        return e.category + " - " + e.value;
    }

    public filter(e: any) {
        this.openStatusesOnly = e;
        this.openStatusesOnlyChange.emit(this.openStatusesOnly);
    }

    detailsHide() {
        this.detailsActive = false;
    }

    public borderOptions = {
        color: "rgba(232, 239, 242, 1.0)",
        width: 1
    }

    public enabled: boolean = true;
    public duration: number = 100;
    public type: string = 'slide';
    public direction: string = 'right';

    public get animate(): any {
        if (this.enabled) {
            return {
                type: this.type,
                direction: this.direction,
                duration: this.duration
            };
        }

        return false;
    }

    public get hasDirection(): boolean {
        return this.type === 'slide' || this.type === 'expand';
    }

    public onToggle(): void {
        this.show = !this.show;
        console.log('tile button '+ this.show);
    }

    centerClicked() {
        this.setDetailData();
    }

    public axisGridLines = {
        color: 'grey',
        width: 1
    };

    public sumSeries(input: any[]) {
        return input.reduce((acc, cur) => acc + cur, 0);
    }

    matchInStringArray(array: String[], value: string) {
        if (CommonFunctions.hasArrayValue(array) && value.length > 0) {
            if (array.findIndex((elem, i) => { return elem === value; }) != -1) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }

    }

    setFilteredItemsDisplay() {
        this.customerFilters = CommonFunctions.findInObjArr(this.referenceData.customers, this.searchParam.customerIds);
        this.acctClassFilters = CommonFunctions.findInObjArr(this.referenceData.accountClasses, this.searchParam.classIds);
        this.salesPersonFilters = CommonFunctions.findInObjArr(this.referenceData.personsSel, this.searchParam.salesPersonIds);
        this.buyersFilters = CommonFunctions.findInObjArr(this.referenceData.personsSel, this.searchParam.buyerIds);
        this.srvConstFilters = CommonFunctions.findInObjArr(this.referenceData.srvConst, this.searchParam.srvConstInt);
        this.techCreatedFilters = CommonFunctions.findInObjArr(this.constIsSubs, this.searchParam.techCreatedInt);
        this.acctManagerFilters = CommonFunctions.findInObjArr(this.referenceData.acctMgrs, this.searchParam.acctMgrIds);
        this.contractAdminFilters = CommonFunctions.findInObjArr(this.referenceData.getActiveContAdmins(), this.searchParam.contractAdminIds);
        this.serviceManagerFilters = CommonFunctions.findInObjArr(this.referenceData.svcMgrs, this.searchParam.serviceMgrId);
        this.techniciansFilters = CommonFunctions.findInObjArr(this.referenceData.technicians, this.searchParam.technicians);
        this.billerFilters = CommonFunctions.findInObjArr(this.referenceData.billers, this.searchParam.billerIds);
        this.invoiceStatusFilters = CommonFunctions.findInObjArr(this.referenceData.invoiceStatus, this.searchParam.invoiceStatuses);
        this.daysAgedFilters = CommonFunctions.findInObjArr(this.globals.daysAgedOptions, this.searchParam.daysAged)
        this.dispatchStatusFilters = CommonFunctions.findInObjArr(this.referenceData.dispatchStatus, this.searchParam.statusIds);
        this.locationsFilters = CommonFunctions.findInObjArr(this.referenceData.locations, this.searchParam.locationIds);
        this.assignmentStatusFilters = CommonFunctions.findInObjArr(this.referenceData.dispAssignStatus, this.searchParam.assignmentStatus);
        this.divisionFilters = CommonFunctions.findInObjArr(this.referenceData.divisions, this.searchParam.divisionIds);
        this.regionFilters = CommonFunctions.findInObjArr(this.referenceData.regions, this.searchParam.regionIds);
        this.onCallRegionFilters = CommonFunctions.findInObjArr(this.referenceData.onCallRegions, this.searchParam.onCallRegions);
        this.defaultSubmitterFilters = CommonFunctions.findInObjArr(this.referenceData.personsSel, this.searchParam.defaultSubmitterIds);
        this.purchasersFilters = CommonFunctions.findInObjArr(this.referenceData.personsAssignPurchase, this.searchParam.purchaserPersonIds);
        this.priorityFilters = CommonFunctions.findInObjArr(this.referenceData.prioritys, this.searchParam.priorityIds);
        this.projectManagerFilters = CommonFunctions.findInObjArr(this.referenceData.personsSel, this.searchParam.projectManagerIds);
        this.rankFilters = CommonFunctions.findInObjArr(this.referenceData.rankOrders, this.searchParam.rankOrderIds);
    }
}
